import React from "react";
import "@/styles/globals.scss";
import "@tumomento-styles/styles.scss";
import "./Layout.scss";
import { Navbar } from "@/components/ui/Navbar/Navbar";
import { Footer } from "@/components/ui/Footer/Footer";
import { ModalWrapper } from "@tumomento/ui";
import { Location } from "@/interfaces/Location";

export const Layout = ({
  children,
  location,
  showBreadcrumbs,
}: {
  children: React.ReactNode | React.ReactElement;
  location?: Location;
  showBreadcrumbs?: boolean;
}) => {
  return (
    <ModalWrapper>
      <div className="layout">
        <Navbar location={location} showBreadcrumbs={showBreadcrumbs} />
        <main className="layout__main">{children}</main>
        <Footer />
      </div>
    </ModalWrapper>
  );
};
